import React from "react";

export const Fishes = () => (
  <svg
    width="230"
    height="136"
    viewBox="0 0 230 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M93.9147 71.2692C95.0822 63.0494 98.9583 57.3049 101.153 54.0824C104.702 48.945 110.82 42.2664 112.548 43.2939C114.93 44.7417 103.675 57.6318 105.87 73.978C107.831 88.6428 119.413 96.3489 116.191 100.739C114.183 103.448 107.972 102.747 104.002 100.786C93.9614 95.7884 92.6538 80.1895 93.9147 71.2692Z"
        fill="#E1DFB2"
      />
      <path
        d="M43.4316 59.3133C47.9148 51.8874 55.2935 47.5907 59.4965 45.2089C66.2214 41.4259 77.1026 36.9891 79.2042 38.5303C82.0996 40.632 61.8316 49.4122 59.3564 65.6182C57.1148 80.1896 70.7514 91.1182 64.727 94.294C60.991 96.2556 52.4915 93.6402 47.5412 90.5111C35.0255 82.6649 38.5747 67.3929 43.4316 59.3133Z"
        fill="#E1DFB2"
      />
      <path
        d="M78.5504 56.1841C62.2052 44.3681 3.36254 51.3736 0.0935059 76.1264L0.560511 76.5934C9.90061 80.3297 2.42853 79.3956 2.42853 79.3956C8.17269 82.0577 23.1636 100.926 34.0448 102.42C37.4072 102.887 52.0245 104.709 70.7514 99.6181C84.4813 95.8819 92.3737 93.7335 95.0356 87.1483C99.192 76.9203 87.7504 62.8626 78.5504 56.1841Z"
        fill="#E1DFE0"
      />
      <path
        d="M2.42842 79.3955C2.42842 80.6098 7.09848 80.5164 11.0213 80.6565C13.3096 80.7032 14.5239 80.6098 15.3178 80.423C15.7848 80.3296 16.065 80.1895 16.2985 80.0026C16.9523 79.5356 14.8041 78.1345 10.6944 76.9202C6.35127 75.6125 0.700506 75.9862 0.0466988 76.1263C-0.653809 76.2664 2.33502 77.2471 2.84873 78.4614C3.64264 80.096 2.42842 78.9285 2.42842 79.3955Z"
        fill="#4A4A4A"
      />
      <path
        d="M47.4944 91.912C46.2335 89.1565 46.4203 85.0933 46.5137 82.7581C46.7005 79.0219 47.4944 73.1373 48.2883 72.1098C49.4091 70.7554 48.1015 81.7774 52.2579 83.9724C55.9472 85.9807 61.598 79.5356 61.3645 82.8515C61.2244 84.9065 58.8893 89.1565 57.068 91.5851C52.4914 97.6098 48.8487 94.901 47.4944 91.912Z"
        fill="#E1DFB2"
      />
      <path
        d="M33.4377 80.1429C37.487 80.1429 40.7697 76.86 40.7697 72.8104C40.7697 68.7609 37.487 65.478 33.4377 65.478C29.3884 65.478 26.1057 68.7609 26.1057 72.8104C26.1057 76.86 29.3884 80.1429 33.4377 80.1429Z"
        fill="white"
      />
      <path
        d="M33.4375 74.9588C34.624 74.9588 35.5858 73.997 35.5858 72.8105C35.5858 71.624 34.624 70.6621 33.4375 70.6621C32.2511 70.6621 31.2893 71.624 31.2893 72.8105C31.2893 73.997 32.2511 74.9588 33.4375 74.9588Z"
        fill="#4A4A4A"
      />
      <path
        d="M219.072 118.206C215.896 121.662 209.685 121.335 203.334 121.802C200.252 122.036 179.517 119.327 173.492 120.308C169.943 120.915 177.275 118.953 171.391 117.132C168.869 116.338 174.24 114.563 176.434 112.555C176.434 112.555 176.715 110.407 186.382 111.714C191.425 112.462 221.314 115.778 219.072 118.206Z"
        fill="#E1DFE0"
      />
      <path
        d="M216.784 116.245C219.632 115.451 228.692 105.97 229.72 104.989C231.354 103.448 225.517 114.703 225.61 112.555C225.657 111.528 222.761 113.162 222.294 119.047C221.827 124.324 227.898 124.231 226.451 125.492C225.517 126.286 217.391 122.129 215.943 120.401C215.149 119.56 215.616 116.571 216.784 116.245Z"
        fill="#006A9C"
      />
      <path
        d="M186.942 110.593C188.39 110.08 189.09 109.846 190.772 109.799C192.5 109.753 195.955 108.585 196.562 108.772C197.356 109.052 193.06 109.893 192.733 111.901C192.453 113.676 193.247 113.676 191.752 113.582C190.772 113.489 191.098 113.489 189.791 113.629C186.242 113.956 185.541 111.06 186.942 110.593Z"
        fill="#006A9C"
      />
      <path
        d="M184.887 120.821C185.354 121.195 186.709 121.662 187.269 121.802C187.876 121.989 190.912 122.363 191.098 122.316C191.425 122.269 189.511 121.195 189.651 120.261C189.744 119.42 186.288 120.168 185.775 120.074C185.448 120.027 185.541 120.027 185.074 119.841C183.907 119.327 184.467 120.448 184.887 120.821Z"
        fill="#006A9C"
      />
      <path
        d="M178.536 116.898C179.722 116.898 180.684 115.936 180.684 114.75C180.684 113.563 179.722 112.602 178.536 112.602C177.35 112.602 176.388 113.563 176.388 114.75C176.388 115.936 177.35 116.898 178.536 116.898Z"
        fill="white"
      />
      <path
        d="M178.536 116.478C179.052 116.478 179.47 116.06 179.47 115.544C179.47 115.028 179.052 114.61 178.536 114.61C178.02 114.61 177.602 115.028 177.602 115.544C177.602 116.06 178.02 116.478 178.536 116.478Z"
        fill="#4A4A4A"
      />
      <path
        d="M142.997 127.5C139.821 130.956 133.61 130.629 127.259 131.096C124.177 131.33 105.403 131.376 99.332 132.404C95.7827 133.011 98.9584 131.983 93.0274 130.162C90.5056 129.368 94.0548 120.775 96.203 118.766C96.203 118.766 100.219 117.038 109.886 118.346C115.023 119 145.192 125.071 142.997 127.5Z"
        fill="#E1DFE0"
      />
      <path
        d="M140.709 125.538C143.557 124.745 145.893 119.56 146.92 118.58C148.554 117.039 149.629 119.047 150.142 119.56C150.889 120.261 150.656 122.363 150.142 128.247C149.675 133.525 149.068 134.646 147.62 135.953C146.686 136.747 141.316 131.47 139.821 129.742C139.028 128.808 139.495 125.865 140.709 125.538Z"
        fill="#FFE9FC"
      />
      <path
        d="M105.403 116.385C106.851 115.871 107.925 116.245 109.559 116.198C111.287 116.151 114.463 115.077 115.07 115.264C115.864 115.544 118.106 118.253 117.779 120.261C117.498 122.036 115.35 121.709 113.856 121.615C112.875 121.522 106.617 118.299 105.356 118.44C101.807 118.72 104.002 116.852 105.403 116.385Z"
        fill="#FFE9FC"
      />
      <path
        d="M110.073 131.236C110.54 131.61 110.914 131.563 111.521 131.75C112.128 131.937 112.969 134.272 116.331 132.777C116.611 132.637 115.304 129.275 115.444 128.341C115.537 127.5 111.521 130.629 111.007 130.536C110.68 130.489 110.774 130.489 110.307 130.302C109.092 129.788 109.653 130.863 110.073 131.236Z"
        fill="#FFE9FC"
      />
      <path
        d="M98.3047 123.25C99.4911 123.25 100.453 122.288 100.453 121.102C100.453 119.915 99.4911 118.953 98.3047 118.953C97.1183 118.953 96.1565 119.915 96.1565 121.102C96.1565 122.288 97.1183 123.25 98.3047 123.25Z"
        fill="white"
      />
      <path
        d="M98.3046 121.475C98.8205 121.475 99.2386 121.057 99.2386 120.541C99.2386 120.025 98.8205 119.607 98.3046 119.607C97.7888 119.607 97.3706 120.025 97.3706 120.541C97.3706 121.057 97.7888 121.475 98.3046 121.475Z"
        fill="#4A4A4A"
      />
      <path
        d="M148.554 110.874C149.586 110.874 150.422 110.037 150.422 109.006C150.422 107.974 149.586 107.137 148.554 107.137C147.523 107.137 146.686 107.974 146.686 109.006C146.686 110.037 147.523 110.874 148.554 110.874Z"
        fill="white"
      />
      <path
        d="M195.115 77.4808C191.145 81.7775 183.439 81.3571 175.5 81.9643C171.624 82.2445 145.799 78.8352 138.233 80.0962C133.797 80.8434 142.95 78.4148 135.571 76.1731C132.443 75.1923 134.03 69.0275 136.786 66.5522C136.786 66.5522 141.829 64.4038 153.831 66.0385C160.229 66.8791 197.87 74.4451 195.115 77.4808Z"
        fill="#E1DFE0"
      />
      <path
        d="M192.219 75.0521C195.815 74.0246 198.664 67.5796 199.972 66.412C202.026 64.4972 201.326 67.4395 201.98 68.0466C202.867 68.934 199.691 71.2691 199.084 78.6016C198.524 85.1867 203.988 85.7472 202.12 87.3351C200.999 88.3158 192.92 82.4779 191.098 80.2829C190.164 79.162 190.772 75.4724 192.219 75.0521Z"
        fill="#006A47"
      />
      <path
        d="M159.389 65.1977C161.21 64.5439 162.518 65.0109 164.573 64.9642C166.767 64.9175 180.638 65.6181 181.385 65.8516C182.365 66.1785 175.22 67.5329 174.847 70.0082C174.473 72.2499 163.639 67.8131 161.724 67.673C160.51 67.5796 160.883 67.5796 159.295 67.7197C154.859 68.1867 157.661 65.8049 159.389 65.1977Z"
        fill="#006A47"
      />
      <path
        d="M152.571 80.7033C153.131 81.1704 153.645 81.1237 154.345 81.3105C155.092 81.544 160.043 82.6182 160.323 82.5715C160.697 82.5248 158.362 81.1704 158.502 80.0028C158.642 78.9286 154.299 79.8627 153.645 79.7693C153.224 79.6759 153.365 79.7226 152.804 79.489C151.356 78.8819 152.057 80.2363 152.571 80.7033Z"
        fill="#006A47"
      />
      <path
        d="M144.538 75.7995C146.008 75.7995 147.2 74.6077 147.2 73.1374C147.2 71.6672 146.008 70.4753 144.538 70.4753C143.068 70.4753 141.876 71.6672 141.876 73.1374C141.876 74.6077 143.068 75.7995 144.538 75.7995Z"
        fill="white"
      />
      <path
        d="M144.491 75.3325C145.136 75.3325 145.659 74.8097 145.659 74.1649C145.659 73.5201 145.136 72.9973 144.491 72.9973C143.846 72.9973 143.324 73.5201 143.324 74.1649C143.324 74.8097 143.846 75.3325 144.491 75.3325Z"
        fill="#4A4A4A"
      />
      <path
        d="M34.1847 31.2911C36.7639 31.2911 38.8548 29.2001 38.8548 26.6208C38.8548 24.0414 36.7639 21.9504 34.1847 21.9504C31.6055 21.9504 29.5146 24.0414 29.5146 26.6208C29.5146 29.2001 31.6055 31.2911 34.1847 31.2911Z"
        fill="#E8E8E8"
      />
      <path
        d="M101.667 37.8297C103.601 37.8297 105.17 36.2615 105.17 34.327C105.17 32.3925 103.601 30.8242 101.667 30.8242C99.7327 30.8242 98.1646 32.3925 98.1646 34.327C98.1646 36.2615 99.7327 37.8297 101.667 37.8297Z"
        fill="#E8E8E8"
      />
      <path
        d="M47.9614 124.698C49.3799 124.698 50.5299 123.548 50.5299 122.129C50.5299 120.711 49.3799 119.561 47.9614 119.561C46.5428 119.561 45.3928 120.711 45.3928 122.129C45.3928 123.548 46.5428 124.698 47.9614 124.698Z"
        fill="#E8E8E8"
      />
      <path
        d="M55.2001 9.34054C55.716 9.34054 56.1341 8.92235 56.1341 8.40648C56.1341 7.89061 55.716 7.47241 55.2001 7.47241C54.6843 7.47241 54.2661 7.89061 54.2661 8.40648C54.2661 8.92235 54.6843 9.34054 55.2001 9.34054Z"
        fill="#E8E8E8"
      />
      <path
        d="M148.835 41.0988C150.253 41.0988 151.403 39.9488 151.403 38.5301C151.403 37.1115 150.253 35.9614 148.835 35.9614C147.416 35.9614 146.266 37.1115 146.266 38.5301C146.266 39.9488 147.416 41.0988 148.835 41.0988Z"
        fill="#E8E8E8"
      />
      <path
        d="M86.9564 4.67033C88.246 4.67033 89.2914 3.62484 89.2914 2.33516C89.2914 1.04549 88.246 0 86.9564 0C85.6668 0 84.6213 1.04549 84.6213 2.33516C84.6213 3.62484 85.6668 4.67033 86.9564 4.67033Z"
        fill="#E8E8E8"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="230" height="136" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
